import {
  ScaleIcon,
  ArrowsRightLeftIcon,
  DocumentTextIcon,
  UserIcon,
  ChatBubbleBottomCenterTextIcon,
  RectangleGroupIcon,
  BuildingLibraryIcon,
  ShareIcon,
  QueueListIcon,
  PresentationChartBarIcon,
  RectangleStackIcon,
} from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { StyledMenu } from './styles';
import Tooltip from '../Tooltip';
import { useAppSelector } from '../../hooks/useStore';
import { getDecodedUserData } from '../../store/slices/user/utils';

const Menu = () => {
  const { userToken, userData } = useAppSelector((state) => state.user);
  const user = getDecodedUserData(userData as string);

  return (
    <StyledMenu>
      {((!!userToken && user?.permissions?.includes('documentos')) as boolean) && (
        <NavLink to="/documents">
          <Tooltip side="right" content="Documentos">
            <DocumentTextIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('areas-juridicas')) as boolean) && (
        <NavLink to="/legal-areas">
          <Tooltip side="right" content="Áreas jurídicas">
            <BuildingLibraryIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('secoes')) as boolean) && (
        <NavLink to="/sections">
          <Tooltip side="right" content="Seções">
            <RectangleStackIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('condicoes')) as boolean) && (
        <NavLink to="/conditions">
          <Tooltip side="right" content="Condições">
            <ShareIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('variaveis')) as boolean) && (
        <NavLink to="/variables">
          <Tooltip side="right" content="Variáveis">
            <ArrowsRightLeftIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('textos')) as boolean) && (
        <NavLink to="/texts">
          <Tooltip side="right" content="Textos">
            <ChatBubbleBottomCenterTextIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('modelos')) as boolean) && (
        <NavLink to="/models">
          <Tooltip side="right" content="Modelos">
            <RectangleGroupIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('templates')) as boolean) && (
        <NavLink to="/templates">
          <Tooltip side="right" content="Templates">
            <QueueListIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('relatorio')) as boolean) && (
        <NavLink to="/relatorio">
          <Tooltip side="right" content="Relatório">
            <PresentationChartBarIcon className="cursor-pointer" />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('usuarios')) as boolean) && (
        <NavLink to="/users">
          <Tooltip side="right" content="Usuários">
            <UserIcon />
          </Tooltip>
        </NavLink>
      )}
      {((!!userToken && user?.permissions?.includes('jurisprudencia')) as boolean) && (
        <NavLink to="/jurisprudencias">
          <Tooltip side="right" content="Jurisprudência">
            <ScaleIcon />
          </Tooltip>
        </NavLink>
      )}
    </StyledMenu>
  );
};

export default Menu;
